<template>
  <el-dialog title="档案办理" :visible.sync="visible" width="1000px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" @close="handleClose">
    <el-form ref="contactFormRef" :rules="contactRules" :model="GraduationArchives" label-width="140px" label-position="left">
      <el-form-item label="本次档案办理方式" prop="processing_method">
        <el-select v-model="GraduationArchives.processing_method" clearable placeholder="请选择本次档案办理方式" @change="onSelect">
          <el-option v-for="item in options.GA_PROCESSING_METHOD_STATE" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <template v-if="GraduationArchives.processing_method !== 'not'">
        <el-form-item label="地址" prop="address">
          <el-input v-model="GraduationArchives.address" placeholder="请输入地址" clearable />
        </el-form-item>
        <el-form-item label="收件人" prop="recipient">
          <el-input v-model="GraduationArchives.recipient" placeholder="请输入收件人" clearable />
        </el-form-item>
        <el-form-item label="手机号" prop="recipient_phone">
          <el-input v-model="GraduationArchives.recipient_phone" placeholder="请输入手机号" clearable />
        </el-form-item>
        <el-form-item label="邮编" prop="postal_code"> <el-input v-model="GraduationArchives.postal_code" placeholder="请输入邮编" clearable /> </el-form-item></template>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button size="small" type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'
import { Message } from 'element-ui'
import api from '@/api'
defineProps({
  options: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const contactFormRef = ref('')
const contactRules = ref({
  processing_method: { required: true, message: '请选择本次档案办理方式' },
  address: { required: false, message: '请输入地址' },
  recipient: { required: false, message: '请输入收件人' },
  recipient_phone: { required: false, message: '请输入手机号' },
  postal_code: { required: false, message: '请输入邮编' }
})
const GraduationArchives = ref({
  processing_method: '',
  address: '',
  recipient: '',
  recipient_phone: '',
  postal_code: ''
})

const onSelect = val => {
  let required = false
  if (['tickets', 'byo'].includes(val)) {
    required = true
  } else {
    required = false
  }
  for (const key in contactRules.value) {
    if (Object.hasOwnProperty.call(contactRules.value, key)) {
      if (key !== 'processing_method') {
        const element = contactRules.value[key]
        element.required = required
      }
    }
  }
}

const visible = ref(false)
const openFn = params => {
  visible.value = true
  GraduationArchives.value = JSON.parse(JSON.stringify(params.GraduationArchives))
}

function submit() {
  const submitForm = {
    step: 2,
    GraduationArchives: GraduationArchives.value
  }
  api.updateGraduationArchives(submitForm).then(res => {
    if (+res.code === 200) {
      Message.success(res.msg)
      handleClose()
      emits('update')
    } else {
      Message.error(res.msg)
    }
  })
}
function handleClose() {
  visible.value = false
}

const emits = defineEmits(['update'])

defineExpose({ openFn })
</script>

<style lang="scss" scoped></style>
